import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ToursIntro() {
  const handleScrollToCatalogue = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById("day-trip-excursions");
    if (el) {
      el.scrollIntoView({
        behavior: "smooth"
      });
      window.history.pushState(null, "", "#day-trip-excursions");
    }
  };
  return <section id="toursexcursionsintro" data-nav="light" aria-labelledby="tours-excursions-title" className="bg-background text-foreground pt-14 pb-8 sm:pt-20 sm:pb-10 md:pt-24 md:pb-12">
      <div className="mx-auto max-w-[1136px] px-6">
        <div className="max-w-3xl">
          <h1 id="tours-excursions-title" className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl font-default">
            Ausflüge & Touren ab Hurghada
          </h1>

          <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg sm:leading-relaxed">
            Entdecke Inseln im Roten Meer, Wüstenabenteuer, kulturelle Tagesausflüge und Erlebnisse vor Ort mit Hurghada Transfer Hub. Dein Hoteltransfer ist ausschließlich für dich und deine Begleitung reserviert. Der Ausflug selbst findet je nach gebuchtem Angebot in einer Gruppe oder privat statt.
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-4">
            <Button asChild className="rounded-lg bg-primary text-primary-foreground font-semibold shadow-sm hover:bg-primary/90 transition-colors">
              <Link to="#day-trip-excursions" onClick={handleScrollToCatalogue}>
                Ausflüge entdecken
              </Link>
            </Button>
          </div>

          <div className="mt-6">
            <Link to="/PrivateDriverHireDEPage" className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground underline underline-offset-4 decoration-border transition-colors hover:text-primary hover:decoration-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              Suchst du stattdessen einen privaten Fahrer auf Stundenbasis?
              <ArrowRight className="size-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}